
import placeholder from "../assets/img/ph.webp"

export const team = [
  {
    name: "Adithya R",
    designation: "President",
    img: placeholder,

    github: "https://github.com/SakthiSaravananV",
    linkedin: "https://www.linkedin.com/in/sakthisaravanan-v/",
    website: "",
  },
  {
    name: "Joel Samuel Raj A",
    designation: "Secretary",
    img: placeholder,
    github: "https://github.com/sthiyanesh/",
    linkedin: "https://www.linkedin.com/in/thiyanesh-s/",
  },
  {
    name: "Jeremy Ashirwad P",
    designation: "Treasurer",
    img: placeholder,
    github: "https://github.com/Narenkumar1234",
    linkedin: "https://www.linkedin.com/in/nightgamer01/",
  },
  {
    name: "Jayaprakash M",
    designation: "Competitive Programming Lead",
    img: placeholder,
    github: "https://github.com/ariharan2001",
    linkedin: "https://www.linkedin.com/in/ariharan-d-6519711b0",
  },
  {
    name: "Noufal Rahman",
    designation: "Web Development Lead",
    img: placeholder,
    github: "https://github.com/iamnoufal",
    linkedin: "https://www.linkedin.com/in/iamnoufal",
    website: "https://noufal.engineer"
  },
  {
    name: "Raghav Jindal",
    designation: "App Development Lead",
    img: placeholder,
    github: "https://github.com/kumarlm",
    linkedin: "https://www.linkedin.com/in/kumarlm/",
  },
  {
    name: "Ashwin Preyan",
    designation: "ML Lead",
    img: placeholder,
    github: "https://github.com/iamnoufal",
    linkedin: "https://www.linkedin.com/in/iamnoufal",
  },
  {
    name: "Akshaya T Aloshious",
    designation: "Placement Lead",
    img: placeholder,
    github: "https://github.com/iamnoufal",
    linkedin: "https://www.linkedin.com/in/iamnoufal",
  },
  {
    name: "Vishali S",
    designation: "Event Coordinator",
    img: placeholder,
    linkedin: "https://www.linkedin.com/in/yuvanesh-p-aa45811b3",
  },
];
